module.exports = __webpack_public_path__ + "img/spx.a6f64ea8.svg";